export default function slugify(str) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '_';

  if (!str) {
    return str;
  }

  return str.toString().trim().toLowerCase().replace(/[^a-z0-9]+/gi, separator).replace(/\//g, separator).replace(/^_+|_+$/gi, '');
}